const account = (state = {}, action) => {
	switch (action.type) {
		case 'SET_USER':
		case 'POOL_ACCESS':
		case 'ROLE_ACCESS':
		case 'IS_ADMIN':
		// case 'POOL_ROLE_ACCESS':
		// case 'SET_USER_POOL':
			return { ...state, ...action.data };
		case 'USER_LOGOUT':
			return {};
		default:
			return state;
	}
};
export default account;
